import { render, staticRenderFns } from "./TeamProfileRequestCard.vue?vue&type=template&id=67b79cbc&scoped=true&"
import script from "./TeamProfileRequestCard.vue?vue&type=script&lang=js&"
export * from "./TeamProfileRequestCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b79cbc",
  null
  
)

export default component.exports